/* ================================================== */
/* ===   INTERRUPTOR: CALCULADORA PLUS (Markegifts) === */
/* ================================================== */
/* Línea SIN comentar  -> modo Plus: producto original + precio por Shopify Function.
   Línea comentada     -> modo de siempre: producto clonado con create-item.php.
   Para cambiar de modo: comentar o descomentar la línea y subir SOLO este fichero.
   Al volver atrás, apagar al menos 7 días ANTES de que termine Shopify Plus.
   Guía: themes-shopify/Markegifts/docs/calculadora-plus.md */
window.MKG_CALCULADORA_PLUS = true;
/* Plus de prueba (acaba hacia el 30/11/2026): aunque el interruptor esté encendido, el modo Plus se apaga solo el
   domingo 29/11/2026 a las 20:00 de Madrid y la calculadora vuelve al modo de siempre. Decisión de Toni, 03/11.
   Si la tienda pasa a Plus de pago, borrar esta línea. */
window.MKG_PLUS_HASTA = Date.parse('2026-11-29T20:00:00+01:00');

/* ================================================== */
/* ===     LOADER “fullscreen-loader” (progresivo)  ===*/
/* ================================================== */
/* ① Constantes y refs */
const LOADER_MIN_MS = 2000;                       // al menos 2 s en pantalla
const loaderEl      = document.getElementById('fullscreen-loader');
const loaderMsgEl   = loaderEl?.querySelector('#loader-message');
const progressBarEl = loaderEl?.querySelector('.progress-bar');

const loaderMessages = [
  '¡Dándole forma a tu idea! 💫',
  'Añadiendo tu producto… 🛒',
  'Cocinando creatividad… 🖌️',
  'Ajustando los últimos detalles… 🔧'
];

const MIN_ORDER_QTY = 1; // Cantidad mínima de pedido

let msgTimer, startTs, stepsTotal = 0, stepsDone = 0;

/* ------------- LABEL DE PREPARACIÓN POR TÉCNICA ------------- */
function getMarcajeSetupLabel(techniqueName) {
  const name = String(techniqueName || '');
  if (/transfer/i.test(name)) return 'Preparación del dibujo';
  if (/tampograf|serigraf|screenprint/i.test(name)) return 'Cliché';
  if (/l[aá]ser/i.test(name)) return 'Preparación del grabado';
  return 'Preparación del dibujo';
}

function calculateProductTotals() {
  let totalProductCost = 0;
  let totalQty = 0;

  document.querySelectorAll('.qty-input').forEach(input => {
    const qty = parseInt(input.value, 10) || 0;
    const unitPrice = precioUnitarioDe(input);

    if (qty > 0) {
      totalProductCost += qty * unitPrice;  // subtotal producto
      totalQty += qty;
    }
  });

  return { totalProductCost, totalQty };
}


/* ② Mostrar */
function showLoader(totalSteps = 1) {
  if (!loaderEl) return;           // por si falta el markup
  stepsTotal = totalSteps;
  stepsDone  = 0;
  progressBarEl.style.width = '0%';
  loaderMsgEl.textContent   = loaderMessages[0];
  loaderEl.classList.add('show');
  startTs = Date.now();

  let idx = 0;
  clearInterval(msgTimer);
  msgTimer = setInterval(() => {
    idx = (idx + 1) % loaderMessages.length;
    loaderMsgEl.textContent = loaderMessages[idx];
  }, 2000);
}

/* ③ Avanzar 1 paso */
function stepLoader() {
  if (!loaderEl) return;
  stepsDone++;
  const pct = Math.min(100, (stepsDone / stepsTotal) * 100);
  progressBarEl.style.width = pct + '%';
}

/* ④ Ocultar */
function hideLoader() {
  if (!loaderEl) return;
  const elapsed = Date.now() - startTs;
  const wait    = Math.max(0, LOADER_MIN_MS - elapsed);

  setTimeout(() => {
    progressBarEl.style.width = '100%';
    loaderEl.classList.remove('show');
    clearInterval(msgTimer);
  }, wait);
}

// Convierte "1.234,56 €" a 1234.56
function parseMoneyValue(str) {
  if (!str) return 0;
  const cleaned = str
    .replace(/[^\d,.,-]/g, '')  // deja solo dígitos, . , y -
    .replace(/\./g, '')         // quita separadores de miles
    .replace(',', '.');         // coma decimal -> punto
  const num = parseFloat(cleaned);
  return isNaN(num) ? 0 : num;
}

function readMoneyFrom(id) {
  const el = document.getElementById(id);
  if (!el) return 0;
  const txt = el.textContent || el.innerText || '';
  return parseMoneyValue(txt);
}


let pesoUnitario;
let pesoTotal;

// Precio por unidad del producto en la calculadora (siempre va personalizado): el de la variante, o el del regalo
// del día de la Marke Week si este producto lo es y toca ahora (snippets/marke-week-producto.liquid)
function precioUnitarioDe(input) {
  if (!window.mwPrecio) return Number(input.dataset.unitPrice) || 0;
  return window.mwPrecio(Number(input.dataset.normalPrice || input.dataset.unitPrice) || 0, true);
}

function getPriceForQuantity(quantity) {
  const numericQuantity = Number(quantity) || 0;

  if (!window.tramosDePrecios || window.tramosDePrecios.length < 1) {
    return window.initialProductPrice || 0;
  }

  let tramosParaCalcular = [...window.tramosDePrecios].sort((a, b) => a.cantidad - b.cantidad);

  // REGLA DE OMISIÓN: Si el primer y último precio son iguales, se quita el primer tramo.
  if (tramosParaCalcular.length > 1) {
    const primerTramo = tramosParaCalcular[0];
    const ultimoTramo = tramosParaCalcular[tramosParaCalcular.length - 1];

    if (primerTramo.precio_final_calculado === ultimoTramo.precio_final_calculado) {
      tramosParaCalcular.shift(); // .shift() elimina el primer elemento del array.
    }
  }

  // REGLA 1: Para muestras (cantidad 0 o 1), el precio es el más bajo de TODOS los tramos originales.
  if (numericQuantity <= 1) {
    const todosLosPrecios = window.tramosDePrecios.map(t => t.precio_final_calculado);
    return Math.min(...todosLosPrecios);
  }

  // REGLA 2: Para el resto de cantidades, usamos la lista de tramos ya preparada.
  const tramosAplicables = tramosParaCalcular.filter(t => numericQuantity >= t.cantidad);

  // Si la cantidad SÍ entra en al menos un tramo, cogemos el más específico.
  if (tramosAplicables.length > 0) {
    return tramosAplicables[tramosAplicables.length - 1].precio_final_calculado;
  }
  
  // ▼▼▼ AQUÍ ESTÁ EL CAMBIO CLAVE ▼▼▼
  // Si la cantidad NO entra en ningún tramo (ej: es 2, y el primer tramo empieza en 250),
  // aplicamos el precio del primer tramo disponible en nuestra lista de cálculo.
  if (tramosParaCalcular.length > 0) {
    return tramosParaCalcular[0].precio_final_calculado; // Devolverá 0.95€
  }

  // Fallback final por si algo va mal.
  return window.initialProductPrice || 0;
}

// ——————————————————————————————
// 1) Helper: crea el producto oculto clonando la variante
// ——————————————————————————————
async function createDynamicVariant({
  originalVariantId,
  qty,
  baseCost,
  extrasTotal,
  grandTotal,
  extras,
  imageFile,
  pesoUnitario,
  pesoTotal
}) {
  const fd = new FormData();
  fd.append('originalVariantId', originalVariantId);
  fd.append('qty',               qty);
  fd.append('baseCost',          baseCost);
  fd.append('extrasTotal',       extrasTotal);
  fd.append('grandTotal',        grandTotal);
  fd.append('extras',            extras);      // ya viene string
  fd.append('env',               1);

  // Evitar errores si vienen indefinidos
  const pU = (typeof pesoUnitario === 'number' && !isNaN(pesoUnitario)) ? pesoUnitario : 0;
  const pT = (typeof pesoTotal    === 'number' && !isNaN(pesoTotal))    ? pesoTotal    : 0;

  fd.append('pesoUnitario', pU.toFixed(2));
  fd.append('pesoTotal',    pT.toFixed(2));

  if (imageFile) {
    fd.append('file', imageFile);
  }

  const resp = await fetch('https://calculadora.mktextil.com/create-item.php', {
    method: 'POST',
    body:   fd
  });
  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(`PHP app error: ${txt}`);
  }
  const data = await resp.json();
  if (!data.variantId) throw new Error('No se devolvió variantId');
  return {
    variantId: data.variantId,
    uniqueRef: data.uniqueRef,
    imageUrl:  data.imageUrl || ''
  };
}


let pricesMap = {};

function normalizeTechniqueKey(value) {
  return String(value || '').trim().toUpperCase();
}

/* Selección de fichero de precios por proveedor (fase 2).
   Devuelve las URLs a intentar en orden; la última siempre es el legacy. */
function pricesAssetUrls(legacyUrl, vendor) {
  const v = String(vendor || '');
  const map = [
    [/makito/i, 'makito'],
    [/roly|stamina/i, 'roly'],
    [/cifra/i, 'cifra'],
    [/pf\s*concept/i, 'pfconcept'],
    [/mid\s*ocean/i, 'midocean'],
  ];
  const hit = map.find(([re]) => re.test(v));
  if (!hit || !/prices\.json/.test(String(legacyUrl || ''))) return [legacyUrl];
  return [String(legacyUrl).replace(/prices\.json/, 'prices-' + hit[1] + '.json'), legacyUrl];
}

/* Copia de fetchPricesWithFallback con cache: 'no-store', comportamiento
   original de Markegifts (las demás tiendas nunca tuvieron no-store). */
async function fetchPricesWithFallback(urls) {
  for (const url of urls) {
    try {
      const r = await fetch(url, { cache: 'no-store' });
      if (!r.ok) continue;
      const json = await r.json();
      if (Array.isArray(json) && json.length) return json;
    } catch (e) { /* siguiente URL */ }
  }
  return [];
}

if (typeof window !== 'undefined') {
  window.pricesAssetUrls = pricesAssetUrls;
  window.fetchPricesWithFallback = fetchPricesWithFallback;
}

// DTF ampliado (03/11): la tarifa DTF1 (100901) está en la general de Markegifts (prices.json, que sale de la de
// Makito), pero no en las de Roly ni PF Concept, que se regeneran fuera. Si el producto ofrece DTF1 y su tarifa no lo
// trae, se toma de la general. Solo en esos productos: los demás no descargan nada de más.
async function conTarifaDtf1(prices, urls, legacyUrl) {
  const lista = Array.isArray(prices) ? prices : [];
  const usaDtf1 = typeof areasData !== 'undefined' && Array.isArray(areasData)
    && areasData.some((a) => (a?.tecnicas || []).some((t) => String(t?.code_tec_ref) === '100901'));
  if (!usaDtf1 || urls.length < 2 || lista.some((x) => String(x?.technique_ref) === '100901')) return lista;
  const general = await fetchPricesWithFallback([legacyUrl]);
  return lista.concat(general.filter((x) => String(x?.technique_ref) === '100901'));
}

async function ensurePricesLoaded() {
  if (Array.isArray(window.pricesJson) && window.pricesJson.length > 0) {
    return window.pricesJson;
  }

  if (!window.pricesAssetUrl) {
    window.pricesJson = Array.isArray(window.pricesJson) ? window.pricesJson : [];
    return window.pricesJson;
  }

  try {
    const urls = pricesAssetUrls(window.pricesAssetUrl, window.productVendor);
    window.pricesJson = await fetchPricesWithFallback(urls);
    window.pricesJson = await conTarifaDtf1(window.pricesJson, urls, window.pricesAssetUrl);
  } catch (error) {
    console.error('No se pudo cargar prices.json:', error);
    window.pricesJson = Array.isArray(window.pricesJson) ? window.pricesJson : [];
  }

  return window.pricesJson;
}

function findPriceConfigByTechnique(technique) {
  if (!window.pricesJson || !Array.isArray(window.pricesJson)) return null;

  const codeRef = normalizeTechniqueKey(technique?.code_tec_ref);
  const techniqueRef = normalizeTechniqueKey(technique?.technique_ref);

  return window.pricesJson.find((item) => {
    const itemCode = normalizeTechniqueKey(item?.code);
    const itemRef = normalizeTechniqueKey(item?.technique_ref);

    return (codeRef && (itemCode === codeRef || itemRef === codeRef)) ||
      (techniqueRef && (itemRef === techniqueRef || itemCode === techniqueRef));
  }) || null;
}

function buildPriceTiersFromConfig(config) {
  if (!config || typeof config !== 'object') return [];

  const tiers = [];
  const cliche = Number(config.cliche) || 0;

  for (let i = 1; i <= 20; i++) {
    const rawPrice = config[`price_${i}`];
    const rawPriceCol = config[`price_col_${i}`];
    const rawPriceCm = config[`price_cm_${i}`];
    if (
      (rawPrice === undefined || rawPrice === null || rawPrice === '') &&
      (rawPriceCol === undefined || rawPriceCol === null || rawPriceCol === '') &&
      (rawPriceCm === undefined || rawPriceCm === null || rawPriceCm === '')
    ) continue;

    const price = Number(rawPrice);
    const priceCol = Number(rawPriceCol);
    const priceCm = Number(rawPriceCm);
    if (!Number.isFinite(price) && !Number.isFinite(priceCol) && !Number.isFinite(priceCm)) continue;

    let qty = Number(config[`section_${i}`]);
    if (!Number.isFinite(qty) || qty <= 0) {
      if (tiers.length === 0) {
        qty = 1;
      } else {
        continue;
      }
    }

    tiers.push({
      cantidad_minima: qty,
      precio_unitario: Number.isFinite(price) ? price : 0,
      price_col: Number.isFinite(priceCol) ? priceCol : 0,
      price_cm: Number.isFinite(priceCm) ? priceCm : 0,
      cargo_cliche: cliche
    });
  }

  return tiers.sort((a, b) => a.cantidad_minima - b.cantidad_minima);
}

function getTechniquePriceTiers(technique) {
  if (Array.isArray(technique?.precios) && technique.precios.length > 0) {
    return technique.precios;
  }

  const config = findPriceConfigByTechnique(technique);
  return buildPriceTiersFromConfig(config);
}

function getBaseTariffForQuantity(tiers, quantity) {
  const sorted = (Array.isArray(tiers) ? tiers : [])
    .filter((t) => Number.isFinite(Number(t?.cantidad_minima)))
    .sort((a, b) => Number(a.cantidad_minima) - Number(b.cantidad_minima));

  if (!sorted.length) {
    return { precio_unitario: 0, price_col: 0, price_cm: 0, cargo_cliche: 0 };
  }

  const q = Number(quantity) || 0;
  const applicable = sorted.filter((t) => Number(t.cantidad_minima) <= q);

  return applicable.length ? applicable[applicable.length - 1] : sorted[0];
}

// marcaje_json de Makito trae las medidas en cm; el resto de proveedores en mm.
// Los inputs del modal (y calculateMarkingCost) trabajan siempre en mm.
function marcajeDimToMm(value, vendor) {
  const n = Number(value) || 0;
  return /makito/i.test(String(vendor || '')) ? n * 10 : n;
}
if (typeof window !== 'undefined') window.marcajeDimToMm = marcajeDimToMm;

function calculateMarkingCost(baseTariff, numColors, width, height, quantity, minCharge, minDecoQty) {
  // Los inputs llegan SIEMPRE en mm: los cm de Makito se convierten a mm al
  // pintar los campos (marcajeDimToMm en updateAreaOptions).
  const widthCm = (Number(width) || 0) / 10;
  const heightCm = (Number(height) || 0) / 10;
  const areaCm2 = widthCm * heightCm;
  const unitByCm = Number(baseTariff?.price_cm) || 0;
  const firstColorPrice = Number(baseTariff?.precio_unitario) || 0;
  const extraColorPrice = Number(baseTariff?.price_col) || 0;

  let unitMarkingCost = 0;

  if (unitByCm > 0 && areaCm2 > 0) {
    unitMarkingCost = unitByCm * areaCm2;
  } else if (numColors <= 1) {
    unitMarkingCost = firstColorPrice;
  } else {
    unitMarkingCost = firstColorPrice + ((numColors - 1) * extraColorPrice);
  }

  // PFConcept-style decoration minimum: when ordering with personalization
  // below the supplier's minDecoQty, bill the marking as if for minDecoQty
  // units (mirrors the LTM surcharge PFConcept charges upstream). Other
  // providers pass minDecoQty = 0 and this branch is a no-op.
  const qty = Number(quantity) || 0;
  const minQty = Number(minDecoQty) || 0;
  const billableQty = Math.max(qty, minQty);
  const minDecoQtyApplied = minQty > 0 && qty > 0 && qty < minQty;

  let subtotal = unitMarkingCost * billableQty;
  let minChargeApplied = false;

  if (minCharge > 0 && subtotal < minCharge) {
    subtotal = minCharge;
    minChargeApplied = true;
  }

  const effectiveUnitMarkingCost = qty > 0 ? (subtotal / qty) : unitMarkingCost;

  return {
    unitMarkingCost,
    effectiveUnitMarkingCost,
    subtotal,
    minChargeApplied,
    minDecoQtyApplied,
    billableQty
  };
}

/* Coste de marcaje de UN área para el total de unidades del pedido.
   Función pura: la usan updateQuote() (lo que se pinta) y la rama Plus de
   addToCart() (lo que se cobra), para que no puedan divergir. */
function quoteAreaCost(technique, selectedColorsStr, repite, width, height, totalUnits) {
  // Tramo de precios según cantidad total
  const baseTariff = getBaseTariffForQuantity(getTechniquePriceTiers(technique), totalUnits);

  // Nº de colores (Full color = 1 por defecto)
  const selectedColors = parseInt(selectedColorsStr, 10);
  const numColors = isNaN(selectedColors) ? 1 : selectedColors;

  // Cliché
  const clichePorColor = baseTariff.cargo_cliche || 0;
  let cargoClicheTotal = clichePorColor * numColors;
  if (repite) cargoClicheTotal = cargoClicheTotal / 2;

  // Mínimo de importe de MARCAJE (sin cliché) desde pricesJson según code_tec_ref
  const priceConfig = findPriceConfigByTechnique(technique);
  const minImporteMarcaje =
    priceConfig && typeof priceConfig.min === 'number'
      ? priceConfig.min
      : 0;

  const marking = calculateMarkingCost(
    baseTariff,
    numColors,
    width,
    height,
    totalUnits,
    minImporteMarcaje,
    window.minDecoQty || 0
  );

  return {
    numColors,
    clichePorColor,
    cargoClicheTotal,
    precioUnitarioMarcaje: marking.effectiveUnitMarkingCost,
    subTotalMarcaje: marking.subtotal,
    minChargeApplied: marking.minChargeApplied,
    minDecoQtyApplied: marking.minDecoQtyApplied,
    billableQty: marking.billableQty,
    // Total del área = marcaje (ajustado al mínimo) + cliché
    subTotalArea: marking.subtotal + cargoClicheTotal
  };
}

/* Técnicas que se cobran por superficie (DTF, transfer a todo color…): su tarifa trae precio por cm². En esas el
   cliente dice cuánto mide su diseño y se cobra eso; en el resto el tamaño no cambia el precio. */
function cobraPorSuperficie(technique) {
  return getTechniquePriceTiers(technique).some((tramo) => Number(tramo?.price_cm) > 0);
}

/* Medida del diseño (mm) dentro del máximo de la técnica (mm), admitiendo girarlo: un diseño de 28 × 25 cabe en un
   máximo de 25 × 28. Devuelve [ancho, alto] en mm, recortados a lo que cabe. */
function medidaDentro(ancho, alto, maxAncho, maxAlto) {
  const girado = (ancho > alto) !== (maxAncho > maxAlto) && ancho !== alto && maxAncho !== maxAlto;
  const [limiteAncho, limiteAlto] = girado ? [maxAlto, maxAncho] : [maxAncho, maxAlto];
  return [Math.min(ancho, limiteAncho), Math.min(alto, limiteAlto)];
}

function mmEnCm(mm) {
  return String(Math.round(Number(mm) || 0) / 10).replace('.', ',');
}

/* «8 × 8 cm»: la medida que se cobra, solo si la técnica se cobra por superficie (va al desglose y al pedido, para
   que el taller sepa qué tamaño se ha pagado). En el resto, ''. */
function medidaCobradaTexto(item, technique) {
  if (!technique || !cobraPorSuperficie(technique)) return '';
  const ancho = Number(item?.querySelector('.ancho-input')?.value) || 0;
  const alto = Number(item?.querySelector('.alto-input')?.value) || 0;
  return ancho > 0 && alto > 0 ? `${mmEnCm(ancho)} × ${mmEnCm(alto)} cm` : '';
}

function hasPositiveNumber(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0;
}

function isTechniqueBillable(technique) {
  // Bordado desactivado: no se ofrece como técnica seleccionable en la calculadora.
  if (/bordado/i.test(technique?.nombre || '')) return false;

  if (Array.isArray(technique?.precios) && technique.precios.length > 0) {
    const hasPositiveTier = technique.precios.some((tier) =>
      hasPositiveNumber(tier?.precio_unitario) ||
      hasPositiveNumber(tier?.price_col) ||
      hasPositiveNumber(tier?.price_cm) ||
      hasPositiveNumber(tier?.cargo_cliche)
    );

    if (hasPositiveTier) return true;
  }

  const config = findPriceConfigByTechnique(technique);
  if (!config) return false;

  if (
    hasPositiveNumber(config.min) ||
    hasPositiveNumber(config.cliche) ||
    hasPositiveNumber(config.cliche_repetition)
  ) {
    return true;
  }

  for (let i = 1; i <= 20; i++) {
    if (
      hasPositiveNumber(config[`price_${i}`]) ||
      hasPositiveNumber(config[`price_col_${i}`]) ||
      hasPositiveNumber(config[`price_cm_${i}`])
    ) {
      return true;
    }
  }

  return false;
}

window.addEventListener('DOMContentLoaded', async () => {
  await ensurePricesLoaded();

  // Modal
  const bsModal       = new bootstrap.Modal(document.getElementById('personalizeModal'));
  const btnPersonal   = document.getElementById('btnPersonalizar');
  
  btnPersonal.addEventListener('click', () => {
    const totalSelected = [...document.querySelectorAll('.qty-input')]
      .reduce((s, i) => s + (Number(i.value) || 0), 0);
    if (totalSelected === 0) {
      alert('Debes indicar al menos una unidad antes de personalizar.');
      return;
    }
    updateVariantQtySum();
    bsModal.show();
  });

  // Botón “Volver” cierra el modal
  const btnBack = document.getElementById('btnBack');
  if (btnBack) btnBack.addEventListener('click', () => bsModal.hide());

  // Inicializa precio/cantidad
  document.getElementById('quoteUnitPrice').value = initialProductPrice;
  const mainQty = document.querySelector('input[name="quantity"]');
  const qtyIn   = document.getElementById('quoteQty');
  if (mainQty) {
    qtyIn.value = mainQty.value;
    mainQty.addEventListener('input', () => {
      qtyIn.value = mainQty.value;
      updateVariantQtySum();
    });
  }

  // Sincroniza sumatorio de variantes con mínimo aplicado
  function updateVariantQtySum() {
    const warningEl = document.getElementById('minQtyWarning');
    const qtyIn = document.getElementById('quoteQty');

    // 1. Calculamos el número real de productos que el usuario ha seleccionado.
    const realTotal = [...document.querySelectorAll('.qty-input')]
                        .reduce((s, i) => s + (Number(i.value) || 0), 0);
    
    let calculatedTotal = realTotal;

    // 2. Comprobamos si se debe aplicar la regla del pedido mínimo.
    if (realTotal > 0 && realTotal < MIN_ORDER_QTY) {
      // Si es así, forzamos el total para el cálculo al mínimo.
      calculatedTotal = MIN_ORDER_QTY;
      
      // Y mostramos el mensaje de aviso.
      if (warningEl) {
        warningEl.innerHTML = `<strong>Aviso:</strong> Se está aplicando el coste de personalización para el pedido mínimo de <strong>${MIN_ORDER_QTY} unidades</strong>.`;
        warningEl.style.display = 'block';
      }
    } else {
      // Si no se aplica la regla, nos aseguramos de que el mensaje esté oculto.
      if (warningEl) {
        warningEl.style.display = 'none';
      }
    }

    // 3. Actualizamos el valor del input oculto con la cantidad que se usará para los cálculos.
    qtyIn.value = calculatedTotal;
    
    // 4. Actualizamos el resto de la interfaz.
    updateBreakdown();
    updateQuote();
  }
  document.querySelectorAll('.qty-input')
    .forEach(i=> i.addEventListener('input',updateVariantQtySum));

  // UI
  renderAreas(areasData);
  initQuotation();

  // Botón Añadir a la cesta
  document.getElementById('addToCartBtn')
    .addEventListener('click', addToCart);

  // Inicializar el desglose al cargar
  updateVariantQtySum();
});
// Convierte "1.234,56 €" a 1234.56
function parseMoneyValue(str) {
  if (!str) return 0;
  const cleaned = str
    .replace(/[^\d,.,,-]/g, '') // deja solo dígitos, . , y -
    .replace(/\./g, '')         // quita separadores de miles
    .replace(',', '.');         // coma decimal -> punto
  const num = parseFloat(cleaned);
  return isNaN(num) ? 0 : num;
}

function readMoneyFrom(id) {
  const el = document.getElementById(id);
  if (!el) return 0;
  const txt = el.textContent || el.innerText || '';
  return parseMoneyValue(txt);
}

/* ================================================== */
/* ===  MODO PLUS: alta al carrito como Promoregalo  === */
/* ================================================== */
/* Variante original + unidades reales + property _custom_price. Una Shopify
   Function (Cart Transform, solo con Shopify Plus) pone ese precio a la línea.
   Se activa con el interruptor del principio del fichero. */

// 0.4 -> "0,40 €" (formato de las properties de coste, como Promoregalo)
function formatEurosProp(n) {
  return (Number(n) || 0).toFixed(2).replace('.', ',') + ' €';
}

/* Construye los items de /cart/add.js. Función pura (sin DOM ni red).
   selections: [{ variantId, qty, unitPrice, uniqueRef }]
   areas:      [{ nombreArea, tecnica, colores, pantone, observaciones, archivoUrl,
                  costeUnitMarcaje, costeCliche, subTotalArea }]
   altaId:     identificador de esta alta (ver newAltaId); va en la property oculta _Alta
   Lanza Error si no hay unidades, no hay áreas o alguna variante no tiene precio. */
function buildPlusCartItems({ selections, areas, vendor, altaId }) {
  const lines = (selections || []).filter((s) => Number(s.qty) > 0);
  const totalUnits = lines.reduce((sum, s) => sum + Number(s.qty), 0);
  if (totalUnits <= 0) throw new Error('No has seleccionado unidades.');
  if (!Array.isArray(areas) || areas.length === 0) {
    throw new Error('Selecciona al menos un área de marcaje.');
  }

  // El marcaje de todo el pedido se reparte a partes iguales entre las unidades
  const extrasTotal = areas.reduce((sum, a) => sum + (Number(a.subTotalArea) || 0), 0);
  const extrasPerUnit = extrasTotal / totalUnits;

  return lines.map((s) => {
    const qty = Number(s.qty);
    const unitPrice = Number(s.unitPrice);
    const finalUnitPrice = unitPrice + extrasPerUnit;
    // Sin precio fiable no se añade: la Function ignora importes <= 0 y cobraría el precio base
    if (!Number.isFinite(unitPrice) || unitPrice <= 0 || !Number.isFinite(finalUnitPrice)) {
      throw new Error('No se ha podido calcular el precio de una de las variantes.');
    }

    const props = {};
    if (vendor) props['_Proveedor'] = String(vendor);
    if (s.uniqueRef) props['Ref'] = String(s.uniqueRef);

    areas.forEach((a, i) => {
      const n = i + 1;
      props[`Área ${n}`] = a.nombreArea;
      // El Flow de Shopify etiqueta el pedido como "personalizado" si "Técnica 1" trae valor
      props[`Técnica ${n}`] = String(a.tecnica || '').trim() || 'Marcaje';
      if (a.colores) props[`Nº Colores ${n}`] = a.colores;
      // Lo que mide el diseño que se ha cobrado (técnicas por superficie): el taller lo ve en el encargo
      if (a.medida) props[`Medida ${n}`] = a.medida;
      // Encargos saca de aquí las unidades y los planchados de la línea
      props[`Unidades ${n}`] = qty;
      if (a.pantone) props[`Pantone ${n}`] = a.pantone;
      if (a.observaciones) props[`Observaciones ${n}`] = a.observaciones;
      if (a.archivoUrl) {
        props[`Archivo ${n}`] = a.archivoUrl;
        props[`_Archivo Adjunto ${n}`] = a.archivoUrl;
      }
      props[`Coste Unit. Marcaje ${n}`] = formatEurosProp(a.costeUnitMarcaje);
      if (Number(a.costeCliche) > 0) props[`Coste Cliché ${n}`] = formatEurosProp(a.costeCliche);
    });

    // Precio por unidad que aplica la Function: con punto decimal y 2 decimales
    props['_custom_price'] = finalUnitPrice.toFixed(2);
    props['Personalizado'] = 'Sí';
    // Shopify junta dos líneas con la misma variante y las mismas properties: sin esto,
    // dos altas iguales quedarían en una línea con "Unidades N" de una sola alta
    if (altaId) props['_Alta'] = String(altaId);

    return { id: Number(s.variantId), quantity: qty, properties: props };
  });
}

/* Cantidad mínima y lotes, con los mismos avisos que Promoregalo. Función pura.
   minQty/stepQty: window.minQty y window.stepQty de product-info.liquid (en Markegifts
   custom.cantidad_minima es mínimo y múltiplo de compra). Ausentes o raros = 1.
   Devuelve el aviso para el cliente, o '' si la cantidad vale. */
function checkPlusQuantity(totalUnits, minQty, stepQty) {
  const moq = parseInt(minQty, 10) > 0 ? parseInt(minQty, 10) : 1;
  let step  = parseInt(stepQty, 10) > 0 ? parseInt(stepQty, 10) : 1;
  if (step > moq) step = moq;

  if (totalUnits < moq) return `La cantidad mínima para este producto es de ${moq} unidades.`;
  if (step > 1 && totalUnits % step !== 0) return `La cantidad debe ser múltiplo de ${step} unidades.`;
  return '';
}

// true solo si el interruptor del principio del fichero está sin comentar y no ha llegado el corte de MKG_PLUS_HASTA
function isPlusCartMode() {
  if (typeof window === 'undefined' || window.MKG_CALCULADORA_PLUS !== true) return false;
  return !(window.MKG_PLUS_HASTA && Date.now() >= window.MKG_PLUS_HASTA);
}

// Variantes con unidades, leídas de la tabla de cantidades de la ficha
function collectPlusSelections() {
  return Array.from(document.querySelectorAll('.qty-input'))
    .map((i) => ({
      variantId: parseInt(i.dataset.variantId, 10),
      qty: parseInt(i.value, 10) || 0,
      unitPrice: precioUnitarioDe(i),
      uniqueRef: i.dataset.uniqueRef || ''
    }))
    .filter((s) => s.qty > 0);
}

// Áreas marcadas en el modal, con su coste para el total de unidades
function collectPlusAreas(totalUnits) {
  const out = [];
  document.querySelectorAll('.area-checkbox:checked').forEach((chk) => {
    const idx     = parseInt(chk.dataset.area, 10);
    const area    = areasData[idx];
    const item    = document.getElementById(`collapse${idx}`).closest('.accordion-item');
    const techSel = item.querySelector('.tecnica-select');
    const colSel  = item.querySelector('.colores-select');
    const t       = area.tecnicas[parseInt(techSel.value, 10)];
    // Zona marcada sin técnica elegida: no entra (addToCart ya lo ha pedido antes de llegar aquí)
    if (!t) return;
    const repite  = item.querySelector('.repite-checkbox').checked;
    const fileIn  = item.querySelector('.file-input');

    const cost = quoteAreaCost(
      t,
      colSel.value,
      repite,
      item.querySelector('.ancho-input')?.value,
      item.querySelector('.alto-input')?.value,
      totalUnits
    );

    out.push({
      nombreArea:       area.nombre_area,
      tecnica:          String(t.nombre || '').trim(),
      colores:          colSel.selectedOptions[0]?.textContent.trim() || '',
      medida:           medidaCobradaTexto(item, t),
      pantone:          item.querySelector('.pantone-input').value || '',
      observaciones:    item.querySelector('textarea').value || '',
      file:             fileIn && fileIn.files.length ? fileIn.files[0] : null,
      archivoUrl:       '',
      costeUnitMarcaje: cost.precioUnitarioMarcaje,
      costeCliche:      cost.cargoClicheTotal,
      subTotalArea:     cost.subTotalArea
    });
  });
  return out;
}

// Sube el diseño del cliente a los Archivos de Markegifts y devuelve su URL
async function uploadPlusFile(file) {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('env', '1'); // 1 = mkt-gifts.myshopify.com (Markegifts) en upload-image.php

  const resp = await fetch('https://calculadora.mktextil.com/upload-image.php', {
    method: 'POST',
    body:   fd
  });
  let data = null;
  try { data = await resp.json(); } catch (e) { /* respuesta sin JSON */ }
  if (!resp.ok || !data || !data.success || !data.url) {
    throw new Error((data && data.error) || 'No se pudo subir el archivo.');
  }
  return data.url;
}

// Identificador de un alta al carrito: distinto en cada llamada (contador) y entre páginas (hora + azar)
let altaSeq = 0;
function newAltaId() {
  altaSeq += 1;
  return Date.now().toString(36) + '-' + altaSeq.toString(36) + Math.random().toString(36).slice(2, 6);
}

// Evita el doble alta: se pone al empezar y solo se quita si el alta falla. Si sale bien
// se queda puesta hasta que carga /cart, para que un segundo clic no añada lo mismo.
let plusAddInFlight = false;

// Al volver con "Atrás", el navegador puede restaurar la página tal como quedó (cargador
// visible y bandera puesta): se liberan para poder añadir de nuevo.
if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
  window.addEventListener('pageshow', (event) => {
    if (event && event.persisted) {
      plusAddInFlight = false;
      hideProcessing();
    }
  });
}

async function addToCartPlus() {
  if (plusAddInFlight) return;

  const selections = collectPlusSelections();
  const totalUnits = selections.reduce((sum, s) => sum + s.qty, 0);

  const avisoCantidad = checkPlusQuantity(totalUnits, window.minQty, window.stepQty);
  if (avisoCantidad) {
    alert(avisoCantidad);
    return;
  }

  const areas = collectPlusAreas(totalUnits);

  if (areas.length === 0) {
    alert('Selecciona al menos un área de marcaje.');
    return;
  }

  plusAddInFlight = true;
  const altaId     = newAltaId();
  const conArchivo = areas.filter((a) => a.file);
  showProcessing(conArchivo.length + 1);

  try {
    // 1) Validar precios ANTES de subir nada (lanza Error si algo no cuadra)
    buildPlusCartItems({ selections, areas, vendor: window.productVendor, altaId });

    // 2) Archivos: uno por área. Si alguno falla no se añade nada al carrito.
    await Promise.all(conArchivo.map(async (a) => {
      a.archivoUrl = await uploadPlusFile(a.file);
      stepLoader();
    }));

    // 3) Una sola llamada: o entran todas las variantes o ninguna
    const items = buildPlusCartItems({ selections, areas, vendor: window.productVendor, altaId });
    const cartRes = await fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items })
    });
    if (!cartRes.ok) {
      let msg = 'Error al añadir al carrito.';
      try {
        const err = await cartRes.json();
        msg = err.description || err.message || msg;
      } catch (e) { /* respuesta sin JSON */ }
      throw new Error(msg);
    }

    // Éxito: el cargador y la bandera se quedan puestos hasta que cargue /cart
    stepLoader();
    window.location.href = '/cart';
  } catch (err) {
    console.error('addToCartPlus error:', err);
    plusAddInFlight = false;
    hideProcessing();
    alert('No se ha podido añadir al carrito: ' + err.message);
  }
}

// ——————————————————————————————————————————————
// 3) addToCart: por cada variante seleccionada clona y añade al carrito
// ——————————————————————————————————————————————
// ——————————————————————————————————————————————
// 3) addToCart: por cada variante seleccionada clona y añade al carrito
// ——————————————————————————————————————————————
// ¿Hay alguna zona marcada sin técnica elegida? (el desplegable empieza en «Elige técnica»)
function zonaSinTecnica() {
  return Array.from(document.querySelectorAll('.area-checkbox:checked')).some((chk) => {
    const item = document.getElementById(`collapse${chk.dataset.area}`)?.closest('.accordion-item');
    return !!item && item.querySelector('.tecnica-select')?.value === '';
  });
}

async function addToCart() {
  const delayCheck = document.getElementById('delayCheck');
  if (delayCheck && !delayCheck.checked) {
    const wrap = delayCheck.closest('.delay-check');
    if (wrap) {
      wrap.classList.remove('delay-check--error');
      void wrap.offsetWidth; /* reinicia la animación */
      wrap.classList.add('delay-check--error');
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return;
  }
  // Ninguna técnica viene elegida (Toni, 03/11): una zona marcada sin técnica no se puede añadir
  if (zonaSinTecnica()) {
    alert('Elige la técnica de la zona marcada.');
    return;
  }
  // 1) Selecciones de variantes (tallas)
  const selections = Array.from(document.querySelectorAll('.qty-input'))
    .map(i => {
      const q  = parseInt(i.value, 10) || 0;
      const id = parseInt(i.name.replace('quantity_', ''), 10);
      return { originalVariantId: id, qty: q };
    })
    .filter(sel => sel.qty > 0);

  const totalRealQty = selections.reduce((sum, s) => sum + s.qty, 0);
  if (totalRealQty === 0) {
    alert('No has seleccionado unidades.');
    return;
  }

  // Mínimo total
  if (totalRealQty > 0 && totalRealQty < MIN_ORDER_QTY) {
    alert(`Para la personalización se requiere un pedido mínimo de ${MIN_ORDER_QTY} unidades en total. Has seleccionado ${totalRealQty}.`);
    return;
  }
  // Modo Plus (interruptor al principio del fichero): producto original + _custom_price
  if (isPlusCartMode()) {
    return addToCartPlus();
  }

  const qtyForPricing = totalRealQty;

  // 2) Leer los totales EXACTOS de la calculadora
  const baseCostOrder   = readMoneyFrom('baseCost');     // coste producto total pedido
  const extrasOrder     = readMoneyFrom('extrasTotal');  // personalización total
  const grandTotalOrder = readMoneyFrom('grandTotal');   // total pedido

  // Si por lo que sea no se pueden leer, caemos al comportamiento antiguo
  const useUiTotals = grandTotalOrder > 0;

  showProcessing(selections.length * 2);

  // 3) Buscar fichero de imagen (si lo hay)
  let imageFile = null;
  document.querySelectorAll('.area-checkbox:checked').forEach(chk => {
    const idx = +chk.dataset.area;
    const fi  = document.querySelector(`.file-input[data-area="${idx}"]`);
    if (fi && fi.files.length) {
      imageFile = fi.files[0];
    }
  });

  try {
    for (const [index, { originalVariantId, qty }] of selections.entries()) {

      let baseCost, extrasTotal, grandTotal;

      // pesos por variante
      let pesoUnitario = 0;
      let pesoTotal    = 0;

      if (useUiTotals) {
        // 4.a) Repartimos los totales del pedido según las unidades de cada variante
        const share = qty / qtyForPricing;
        baseCost    = baseCostOrder   * share;
        extrasTotal = extrasOrder     * share;
        grandTotal  = grandTotalOrder * share;
      } else {
        // 4.b) Fallback: cálculo antiguo (sin mínimos de marcaje globales)
        const unitPriceProd = parseFloat(document.getElementById('quoteUnitPrice').value) || 0;
        baseCost = unitPriceProd * qty;

        let extrasTotalRaw = 0;

        document.querySelectorAll('.area-checkbox:checked').forEach(chk => {
          const idx   = +chk.dataset.area;
          const area  = areasData[idx];

          // peso (dejamos el último área como antes)
          pesoUnitario = area.peso_unitario || 0;
          pesoTotal    = pesoUnitario * qty;

          const item    = document.getElementById(`collapse${idx}`).closest('.accordion-item');
          const techSel = item.querySelector('.tecnica-select');
          const colSel  = item.querySelector('.colores-select');
          const repite  = item.querySelector('.repite-checkbox').checked;
          const pantone = item.querySelector('.pantone-input').value || '';
          const anchoIn = item.querySelector('.ancho-input');
          const altoIn = item.querySelector('.alto-input');
          const t       = area.tecnicas[+techSel.value];
          if (!t || techSel.value === '') return;

          const selectedColorsStr = colSel.value;
          let selectedColors = parseInt(selectedColorsStr, 10);

          const baseTariff = getBaseTariffForQuantity(getTechniquePriceTiers(t), qtyForPricing);

          let numColors;
          if (isNaN(selectedColors)) {
            numColors = 1;
          } else {
            numColors = selectedColors;
          }

          const priceConfig = findPriceConfigByTechnique(t);
          const minImporteMarcaje =
            priceConfig && typeof priceConfig.min === 'number'
              ? priceConfig.min
              : 0;

          const { subtotal: subTotalMarcaje } = calculateMarkingCost(
            baseTariff,
            numColors,
            anchoIn?.value,
            altoIn?.value,
            qty,
            minImporteMarcaje,
            window.minDecoQty || 0
          );

          const clichePorColor = baseTariff.cargo_cliche || 0;
          let cargoClicheTotal = clichePorColor * numColors;
          if (repite) cargoClicheTotal = cargoClicheTotal / 2;

          extrasTotalRaw += subTotalMarcaje + cargoClicheTotal;
        });

        extrasTotal = extrasTotalRaw;
        grandTotal  = baseCost + extrasTotal;
      }

      // 5) Construir el array de "extras" SOLO informativo
      const extras = [];
      const medidas = []; // aparte de extras (que va tal cual al servidor): solo para las properties

      document.querySelectorAll('.area-checkbox:checked').forEach(chk => {
        const idx   = +chk.dataset.area;
        const area  = areasData[idx];

        // Peso (en caso de que vengamos de la rama de UI, lo seteamos aquí)
        pesoUnitario = area.peso_unitario || 0;
        pesoTotal    = pesoUnitario * qty;

        const item    = document.getElementById(`collapse${idx}`).closest('.accordion-item');
        const techSel = item.querySelector('.tecnica-select');
        const colSel  = item.querySelector('.colores-select');
        const pantone = item.querySelector('.pantone-input').value || '';
        const t       = area.tecnicas[+techSel.value];
        if (!t || techSel.value === '') return;
        // "2 colores" / "Full color"; vacío si la técnica no usa selector de colores
        const coloresTxt = colSel.selectedOptions[0]?.textContent.trim() || '';
        medidas.push(medidaCobradaTexto(item, t));

        extras.push({
          area:            area.nombre_area,
          tecnica:         coloresTxt ? `${t.nombre.trim()} (${coloresTxt})` : t.nombre.trim(),
          cantidad:        qty,
          // repartimos la personalización de esta variante entre sus uds
          precio_unitario: extrasTotal / qty,
          subtotal:        extrasTotal,
          pantone:         pantone,
          cargo_cliche:    0
        });
      });

      console.log('BaseCost var:', baseCost, 'Extras var:', extrasTotal, 'GrandTotal var:', grandTotal);

      // 6) Crear variant dinámico
      const { variantId, uniqueRef, imageUrl } = await createDynamicVariant({
        originalVariantId,
        qty,
        baseCost,
        extrasTotal,
        grandTotal,
        extras: JSON.stringify(extras),
        imageFile,
        pesoUnitario,
        pesoTotal
      });

      stepLoader();

      // 7) Montar properties legibles
      const base   = Number(baseCost)    || 0;
      const extraT = Number(extrasTotal) || 0;
      const grand  = Number(grandTotal)  || 0;

      const props = {
        'Coste base (€)':            base.toFixed(2).replace('.', ','),
        'Total personalización (€)': extraT.toFixed(2).replace('.', ','),
        'Total (€)':                 grand.toFixed(2).replace('.', ','),
        'Imagen personalización':    imageUrl,
        'Referencia única':          uniqueRef
      };

      extras.forEach((e, i) => {
        const idx = i + 1;
        props[`Área ${idx}`]                = e.area;
        props[`Técnica ${idx}`]             = e.tecnica;
        if (medidas[i]) props[`Medida ${idx}`] = medidas[i];
        props[`Unidades ${idx}`]            = e.cantidad;
        props[`Pantone ${idx}`]             = e.pantone;
        const pu  = parseFloat(e.precio_unitario) || 0;
        const sub = parseFloat(e.subtotal)        || 0;
        props[`Precio unitario ${idx} (€)`] = pu.toFixed(2).replace('.', ',');
        props[`Subtotal marcaje ${idx} (€)`]= sub.toFixed(2).replace('.', ',');
      });

      // 8) Añadir al carrito
      const cartRes = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({
          id:       variantId,
          quantity: 1,
          properties: props
        })
      });
      if (!cartRes.ok) {
        const t = await cartRes.text();
        throw new Error(`Error añadiendo al carrito: ${t}`);
      }
    }

    stepLoader();
    hideProcessing();
    window.location.href = '/cart';

  } catch (err) {
    console.error('addToCart error:', err);
    alert('Error al añadir al carrito. Revisa la consola.');
  }
}


function showProcessing(totalSteps = 1) {
  // sigue enseñando tu overlay semitransparente, si lo quieres
  const ov = document.getElementById('processingOverlay');
  if (ov) ov.style.display = 'flex';

  // ahora lanza el spinner con progreso
  showLoader(totalSteps);
}

function hideProcessing() {
  const ov = document.getElementById('processingOverlay');
  if (ov) ov.style.display = 'none';

  hideLoader();
}

function renderAreas(data) {
  const acc = document.getElementById('areasAccordion');
  acc.innerHTML = '';
  data.forEach((area, idx) => {
    const headId     = `heading${idx}`;
    const collapseId = `collapse${idx}`;
    const validTechniques = (area.tecnicas || []).filter(isTechniqueBillable);

    if (!validTechniques.length) {
      return;
    }

    const options = validTechniques.map((t) => {
  const originalIndex = area.tecnicas.indexOf(t);
  const maxCol = t.colores_max;
  const numMax = parseInt(maxCol, 10);
  let labelColores;

  if (!isNaN(numMax)) {
    // Es numérico → "7 colores", "1 color"
    labelColores = `${numMax} color${numMax > 1 ? 'es' : ''}`;
  } else {
    // No es numérico → usamos el texto tal cual ("Full color", "A todo color", etc.)
    labelColores = String(maxCol);
  }

  return `<option value="${originalIndex}">${t.nombre.trim()} (${labelColores})</option>`;
}).join('');


    acc.insertAdjacentHTML('beforeend', `
      <div class="accordion-item">
        <h2 class="accordion-header" id="${headId}">
          <button class="accordion-button collapsed d-flex align-items-center"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#${collapseId}"
                  aria-expanded="false"
                  aria-controls="${collapseId}">
            <input class="form-check-input area-checkbox"
                    type="checkbox"
                    data-area="${idx}"
                    aria-label="Marcar en ${area.nombre_area}">
            ${area.imagen ? `<img class="mk-area__img" src="${String(area.imagen).replace(/^http:\/\//, 'https://')}" alt="" loading="lazy" onerror="this.remove()">` : ''}
            <span class="mk-area__textos">
              <span class="mk-area__nombre">${area.nombre_area}</span>
              <span class="mk-area__num">${(String(area.zona || '').match(/Área\s*\d+/i) || [area.zona || ''])[0]}</span>
            </span>
            <span class="mk-area__estado">Marcada</span>
          </button>
        </h2>
        <div id="${collapseId}"
             class="accordion-collapse collapse"
             aria-labelledby="${headId}"
             data-bs-parent="#areasAccordion">
          <div class="accordion-body">

            <!-- Técnica / colores -->
            <div class="row g-2 mb-3">
              <div class="col-md-6">
                <label class="form-label">Técnica:</label>
                <select class="form-select tecnica-select" data-area="${idx}">
                  <option value="" selected>Elige técnica</option>
                  ${options}
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Nº Colores:</label>
                <select class="form-select colores-select" data-area="${idx}" disabled></select>
              </div>
            </div>

            <!-- Medidas -->
            <div class="row g-2 mb-3">
              <div class="col">
                <label class="form-label">Ancho (mm):</label>
                <input type="number" class="form-control ancho-input" readonly>
              </div>
              <div class="col">
                <label class="form-label">Alto (mm):</label>
                <input type="number" class="form-control alto-input" readonly>
              </div>
            </div>

            <!-- Lo que mide el diseño: solo en las técnicas que se cobran por superficie (pintarMedidaDiseno) -->
            <div class="mk-medida mb-3" hidden>
              <p class="mk-tecnicas__titulo">¿Cuánto mide tu diseño?</p>
              <div class="mk-medida__campos">
                <label class="mk-medida__campo">
                  <span>Ancho</span>
                  <input type="number" class="form-control mk-medida__ancho" min="1" step="0.1" inputmode="decimal">
                  <span>cm</span>
                </label>
                <span class="mk-medida__por" aria-hidden="true">×</span>
                <label class="mk-medida__campo">
                  <span>Alto</span>
                  <input type="number" class="form-control mk-medida__alto" min="1" step="0.1" inputmode="decimal">
                  <span>cm</span>
                </label>
              </div>
              <p class="mk-medida__nota"><span class="mk-medida__max"></span>. Se cobra por superficie: si tu diseño es más pequeño, pon su medida y pagas menos.</p>
              <div class="mk-aviso mk-medida__aviso" hidden></div>
            </div>

            <!-- Repetición, Pantone, archivo, obs -->
            <div class="form-check mb-3">
              <input class="form-check-input repite-checkbox"
                     type="checkbox"
                     id="repite${idx}">
              <label class="form-check-label" for="repite${idx}">
                Repetición de pedido
                <br><small class="text-muted">(Solo si repites un pedido anterior con el mismo logotipo, imagen y producto)</small>
              </label>
            </div>
            <div class="mb-3">
              <label class="form-label">PANTONE:</label>
            <div class="input-group">
              <!-- Botón que abre el selector nativo -->
              <button type="button" class="input-group-text pantone-picker" title="Elegir color">
                🎨
              </button>
              <input
                type="text"
                class="form-control pantone-input"
                placeholder="Introduce código Pantone"/>
              <!-- selector de color oculto -->
              <input type="color" class="pantone-native d-none"/>
            </div>
            <div class="mt-2 pantone-presets">
              <!-- 6 colores predefinidos -->
              ${['#000000','#FFFFFF','#FF0000','#00FF00','#0000FF','#FFD700']
                .map(c => `<button type="button" class="btn btn-sm pantone-swatch mx-1" 
                               data-color="${c}" 
                               style="background:${c};border:1px solid #ccc;width:24px;height:24px;">
                           </button>`)
                .join('')}
            </div>
            </div>
            <div class="mb-3">
              <label class="form-label">Adjuntar diseño (PDF, JPG, PNG, AI, SVG o ZIP)<br><b>Puedes hacerlo más adelante enviándolo vía email:</b> </label>
              <input type="file" class="file-input form-control form-control-sm" accept=".pdf,.png,.jpg,.jpeg,.svg,.webp,.ai,.eps,.psd,.cdr,.tif,.tiff,.zip" data-area="${idx}"><small class="text-muted d-block" style="margin-top:2px">M&aacute;x. 20 MB por archivo</small>
            </div>
            <div class="mb-3">
              <label class="form-label">Observaciones:</label>
              <textarea class="form-control" rows="2"></textarea>
            </div>
          </div>
        </div>
      </div>
    `);

    const item     = acc.lastElementChild;
    const collapse = item.querySelector('.accordion-collapse');
    const chk      = item.querySelector('.area-checkbox');
    const techSel  = item.querySelector('.tecnica-select');

    collapse.addEventListener('shown.bs.collapse', () => onAreaSelected(idx));
    techSel.addEventListener('change',  () => updateAreaOptions(idx));
    chk.addEventListener('change',      () => updateQuote());

    updateAreaOptions(idx);
  });
  // Selecciona y abre la primera área por defecto
  if (!acc.children.length) {
    acc.innerHTML = '<p class="text-muted small mb-0">No hay tecnicas con tarifa disponible para este producto.</p>';
    return;
  }

  const firstChk = document.querySelector('#areasAccordion .area-checkbox');
  if (firstChk) {
    firstChk.checked = true;
    const firstCollapse = firstChk.closest('.accordion-item')?.querySelector('.accordion-collapse');
    if (firstCollapse) new bootstrap.Collapse(firstCollapse, { toggle: true });
    updateQuote();
  }
}

document.addEventListener('click', e => {
  if (e.target.matches('.pantone-swatch')) {
    const btn   = e.target;
    const color = btn.dataset.color;
    // buscamos el input dentro del mismo accordion-item
    const container = btn.closest('.accordion-body');
    const input = container.querySelector('.pantone-input');
    if (input) {
      input.value = color;
      // opcional: cambiar fondo del input al color elegido
      input.style.backgroundColor = color;
      input.style.color = getContrastYIQ(color);
    }
  }
});

// ——————————————————————————————
// NUEVO: Abrir selector nativo al pulsar el icono
// ——————————————————————————————
document.addEventListener('click', e => {
  if (e.target.matches('.pantone-picker')) {
    const container = e.target.closest('.input-group');
    const native    = container.querySelector('.pantone-native');
    native.click();
  }
});

// ——————————————————————————————
// NUEVO: Capturar cambio del selector nativo
// ——————————————————————————————
document.addEventListener('input', e => {
  if (e.target.matches('.pantone-native')) {
    const color = e.target.value;
    const container = e.target.closest('.input-group');
    const input     = container.querySelector('.pantone-input');
    input.value = color;
    input.style.backgroundColor = color;
    input.style.color = getContrastYIQ(color);
  }
});

function getContrastYIQ(hex) {
  hex = hex.replace('#','');
  const r = parseInt(hex.substr(0,2),16),
        g = parseInt(hex.substr(2,2),16),
        b = parseInt(hex.substr(4,2),16);
  return ((r*299)+(g*587)+(b*114))/1000 >= 128 ? '#000':'#fff';
}

function updateAreaOptions(idx) {
  const area     = areasData[idx];
  const item     = document.getElementById(`collapse${idx}`)
                      .closest('.accordion-item');
  const techSel  = item.querySelector('.tecnica-select');
  const colorSel = item.querySelector('.colores-select');
  const anchoIn  = item.querySelector('.ancho-input');
  const altoIn   = item.querySelector('.alto-input');

  const t = area.tecnicas[parseInt(techSel.value,10)];
  if (!t) {
    // Sin técnica elegida (es como empieza cada zona)
    anchoIn.value = '';
    altoIn.value = '';
    colorSel.innerHTML = '';
    colorSel.disabled = true;
    pintarMedidaDiseno(item, null);
    if (item.querySelector('.area-checkbox').checked) updateQuote();
    return;
  }

  // Medidas en mm (los cm de Makito se convierten al pintar)
  anchoIn.value = marcajeDimToMm(t.ancho, window.productVendor);
  altoIn.value  = marcajeDimToMm(t.alto, window.productVendor);
  pintarMedidaDiseno(item, t);

  // Reiniciamos el select de colores
  colorSel.innerHTML = '';

  const maxRaw = t.colores_max;
  const maxNum = parseInt(maxRaw, 10);

  // 1️⃣ Caso: técnica con nº máximo de colores (ej: 7)
  if (!isNaN(maxNum) && maxNum > 0) {
    for (let c = 1; c <= maxNum; c++) {
      colorSel.insertAdjacentHTML(
        'beforeend',
        `<option value="${c}">${c} color${c > 1 ? 'es' : ''}</option>`
      );
    }
  }

  // 2️⃣ Detectar si en la tarifa hay algo tipo "Full color"
  const hasFullColor = (t.precios || []).some(p => {
    const nc = String(p.numero_colores || '').toLowerCase();
    return nc.includes('full');
  });

  // Si hay “Full color” en la tarifa o el propios colores_max lo es, lo añadimos
  if (hasFullColor || (String(maxRaw).toLowerCase().includes('full') && (isNaN(maxNum) || maxNum <= 0))) {
    colorSel.insertAdjacentHTML(
      'beforeend',
      `<option value="Full color">Full color</option>`
    );
  }

  // Si no hemos añadido nada de nada, metemos al menos una opción genérica
  if (!colorSel.options.length) {
    colorSel.insertAdjacentHTML(
      'beforeend',
      `<option value="1">1 color</option>`
    );
  }

  colorSel.disabled = false;

  if (item.querySelector('.area-checkbox').checked) {
    updateQuote();
  }
}



/* «¿Cuánto mide tu diseño?», solo en las técnicas que se cobran por superficie. Empieza en el máximo de la técnica
   (el precio de siempre); si el cliente pone lo que mide su diseño, .ancho-input y .alto-input (los que lee la
   cuenta) pasan a esa medida. Se recuerda al cambiar de técnica (item.dataset, en mm). */
function pintarMedidaDiseno(item, t) {
  const caja = item.querySelector('.mk-medida');
  if (!caja) return;
  const maxAncho = t ? marcajeDimToMm(t.ancho, window.productVendor) : 0;
  const maxAlto = t ? marcajeDimToMm(t.alto, window.productVendor) : 0;
  caja.hidden = !(maxAncho > 0 && maxAlto > 0 && cobraPorSuperficie(t));
  if (caja.hidden) return;

  caja.querySelector('.mk-medida__max').textContent = `Hasta ${mmEnCm(maxAncho)} × ${mmEnCm(maxAlto)} cm`;
  const disenoAncho = Number(item.dataset.disenoAncho) || 0;
  const disenoAlto = Number(item.dataset.disenoAlto) || 0;
  const [ancho, alto] = disenoAncho > 0 && disenoAlto > 0
    ? medidaDentro(disenoAncho, disenoAlto, maxAncho, maxAlto)
    : [maxAncho, maxAlto];
  item.querySelector('.ancho-input').value = ancho;
  item.querySelector('.alto-input').value = alto;
  caja.querySelector('.mk-medida__ancho').value = ancho / 10;
  caja.querySelector('.mk-medida__alto').value = alto / 10;
  avisoMedida(caja, disenoAncho, disenoAlto, ancho, alto, maxAncho, maxAlto);
}

// Si el diseño no cabe, se dice cuánto es lo máximo (y se cobra eso)
function avisoMedida(caja, disenoAncho, disenoAlto, ancho, alto, maxAncho, maxAlto) {
  const aviso = caja.querySelector('.mk-medida__aviso');
  const recortado = disenoAncho > 0 && disenoAlto > 0 && (ancho < disenoAncho || alto < disenoAlto);
  aviso.hidden = !recortado;
  aviso.textContent = recortado ? `No cabe: en esta zona lo máximo es ${mmEnCm(maxAncho)} × ${mmEnCm(maxAlto)} cm.` : '';
}

// El cliente escribe la medida: al teclear se recalcula; al salir del campo, si no cabía, se deja la que cabe
function aplicarMedidaDiseno(campo, corregir) {
  const item = campo.closest('.accordion-item');
  const sel = item && item.querySelector('.tecnica-select');
  const t = sel ? areasData[parseInt(sel.dataset.area, 10)]?.tecnicas[parseInt(sel.value, 10)] : null;
  if (!t) return;
  const caja = item.querySelector('.mk-medida');
  const campoAncho = caja.querySelector('.mk-medida__ancho');
  const campoAlto = caja.querySelector('.mk-medida__alto');
  const cm = (c) => parseFloat(String(c.value).replace(',', '.'));
  // A medio escribir (vacío o 0) no se toca nada
  if (!(cm(campoAncho) > 0 && cm(campoAlto) > 0)) return;

  // En mm enteros y como poco 1 cm
  const disenoAncho = Math.max(10, Math.round(cm(campoAncho) * 10));
  const disenoAlto = Math.max(10, Math.round(cm(campoAlto) * 10));
  item.dataset.disenoAncho = disenoAncho;
  item.dataset.disenoAlto = disenoAlto;
  const maxAncho = marcajeDimToMm(t.ancho, window.productVendor);
  const maxAlto = marcajeDimToMm(t.alto, window.productVendor);
  const [ancho, alto] = medidaDentro(disenoAncho, disenoAlto, maxAncho, maxAlto);
  item.querySelector('.ancho-input').value = ancho;
  item.querySelector('.alto-input').value = alto;
  avisoMedida(caja, disenoAncho, disenoAlto, ancho, alto, maxAncho, maxAlto);
  if (corregir) {
    campoAncho.value = ancho / 10;
    campoAlto.value = alto / 10;
  }
  updateQuote();
}

document.addEventListener('input', (e) => {
  if (e.target.matches?.('.mk-medida__ancho, .mk-medida__alto')) aplicarMedidaDiseno(e.target, false);
});
document.addEventListener('change', (e) => {
  if (e.target.matches?.('.mk-medida__ancho, .mk-medida__alto')) aplicarMedidaDiseno(e.target, true);
});

function onAreaSelected(idx) {
  const area = areasData[idx];
  const imgSrc = String(area.imagen || '').replace(/^http:\/\//, 'https://');
  const nombreZona = document.getElementById('quoteAreaNombre');
  if (nombreZona) nombreZona.textContent = `Zona: ${area.nombre_area}`;

  document.getElementById('quoteProductoImg').src = imgSrc;

  const quoteImg = document.getElementById('quoteProductoImg');
  if (quoteImg) quoteImg.src = imgSrc;
}

function initQuotation() {
  document.getElementById('quoteUnitPrice')
          .addEventListener('input', updateQuote);
  document.getElementById('quoteQty')
          .addEventListener('input', updateQuote);

  document.getElementById('areasAccordion')
    .addEventListener('change', e => {
      if (e.target.matches('.area-checkbox, .tecnica-select, .colores-select, .repite-checkbox')) {
        updateQuote();
      }
    });

  updateQuote();
}

function updateQuote() {
  // ============================
  // 1) TOTAL PRODUCTO (camisetas)
  // ============================
  const qtyInputs = document.querySelectorAll('.qty-input');

  let totalUnits = 0;
  let totalProductCost = 0;

  qtyInputs.forEach(input => {
    const qty   = parseInt(input.value, 10) || 0;
    const price = precioUnitarioDe(input);

    if (qty > 0) {
      totalUnits       += qty;
      totalProductCost += qty * price;
    }
  });

  const unitPriceInput = document.getElementById('quoteUnitPrice');
  const baseCostEl     = document.getElementById('baseCost');
  const extrasTotalEl  = document.getElementById('extrasTotal');
  const totalPerUnitEl = document.getElementById('totalPerUnit');
  const grandTotalEl   = document.getElementById('grandTotal');
  const totalPerUnitRow = document.querySelector('.total-per-unit-row');
  const extrasTable    = document.getElementById('extrasTable');

  // Si no hay unidades seleccionadas, reseteamos todo y salimos
  if (totalUnits === 0) {
    if (unitPriceInput) unitPriceInput.value = "0.00";
    if (baseCostEl)     baseCostEl.textContent    = formatMoney(0);
    if (extrasTotalEl)  extrasTotalEl.textContent = formatMoney(0);
    if (totalPerUnitEl) totalPerUnitEl.textContent = formatMoney(0);
    if (grandTotalEl)   grandTotalEl.textContent  = formatMoney(0);
    if (extrasTable)    extrasTable.innerHTML     = '';
    if (totalPerUnitRow) totalPerUnitRow.style.display = 'none';
    return;
  }

  // Precio medio por unidad (solo producto)
  const productUnitPrice = totalProductCost / totalUnits;

  if (unitPriceInput) unitPriceInput.value = productUnitPrice.toFixed(2);
  if (baseCostEl)     baseCostEl.textContent = formatMoney(totalProductCost);


  // ===========================================
  // 2) PERSONALIZACIÓN (marcaje + cliché, con mínimo)
  // ===========================================
  if (extrasTable) extrasTable.innerHTML = '';
  let extrasTotal = 0;
  let sinTecnica = false;

  document.querySelectorAll('.area-checkbox:checked').forEach(chk => {
    const idx    = parseInt(chk.dataset.area, 10);
    const area   = areasData[idx];
    const item   = document.getElementById(`collapse${idx}`).closest('.accordion-item');
    const techSel = item.querySelector('.tecnica-select');
    const colSel  = item.querySelector('.colores-select');
    const repite  = item.querySelector('.repite-checkbox').checked;
    const anchoIn = item.querySelector('.ancho-input');
    const altoIn = item.querySelector('.alto-input');

    const t = area.tecnicas[parseInt(techSel.value, 10)];
    if (!t) {
      sinTecnica = true;
      return;
    }
    const selectedColorsStr = colSel.value;
    const selectedColors = parseInt(selectedColorsStr, 10);

    // 2.1 Marcaje (con mínimo) + cliché del área: misma función que cobra la rama Plus
    const {
      numColors,
      clichePorColor,
      cargoClicheTotal,
      precioUnitarioMarcaje,
      subTotalMarcaje: subTotalMarcajeAjustado,
      minChargeApplied,
      minDecoQtyApplied,
      billableQty,
      subTotalArea
    } = quoteAreaCost(t, selectedColorsStr, repite, anchoIn?.value, altoIn?.value, totalUnits);

    extrasTotal += subTotalArea;

    // 2.3 Pintar desglose (mostramos ya el marcaje ajustado)
    const isEmbroidery = /bordado/i.test(t.nombre || '');
    const medida = medidaCobradaTexto(item, t);

    if (extrasTable) {
      extrasTable.insertAdjacentHTML('beforeend', `
        <tr>
          <td>
            <div>${area.nombre_area} — ${t.nombre.trim()} (${selectedColorsStr})</div>
            ${medida ? `<div class="mk-desglose__medida">Medida: ${medida}</div>` : ''}
            ${isEmbroidery ? '<div class="mk-aviso">El precio del bordado se calculará según el número de puntadas del diseño.</div>' : ''}
            ${minChargeApplied ? '<div class="mk-aviso">Se aplica el importe mínimo de marcaje.</div>' : ''}
            ${minDecoQtyApplied ? `<div class="mk-aviso">Personalización facturada como ${billableQty} uds (mínimo del proveedor).</div>` : ''}
          </td>
          <td class="text-center">${totalUnits}</td>
          <td class="text-end">${formatMoney(precioUnitarioMarcaje)}</td>
          <td class="text-end">${formatMoney(subTotalMarcajeAjustado)}</td>
        </tr>
        <tr>
          <td class="ps-3">${getMarcajeSetupLabel(t.nombre)}${repite ? ' (repetición)' : ''}</td>
          <td class="text-center">${isNaN(selectedColors) ? selectedColorsStr : numColors}</td>
          <td class="text-end">${formatMoney(clichePorColor)}</td>
          <td class="text-end">${formatMoney(cargoClicheTotal)}</td>
        </tr>
      `);
    }
  });

  if (sinTecnica && extrasTable) {
    extrasTable.insertAdjacentHTML('beforeend', '<tr><td colspan="4" class="mk-suave">Elige la técnica de la zona marcada para ver el precio.</td></tr>');
  }
  if (extrasTotalEl) extrasTotalEl.textContent = formatMoney(extrasTotal);

  // ===========================================
  // 3) TOTAL POR UNIDAD y TOTAL GENERAL
  // ===========================================
  let grandTotal = totalProductCost + extrasTotal;
  // En modo Plus la cesta cobra cada línea a su precio por unidad redondeado al céntimo (_custom_price en
  // buildPlusCartItems): se enseña ese total, no el exacto (antes: 345,10 € enseñados y 345,00 € cobrados a 6,902 €/u)
  if (isPlusCartMode()) {
    const extrasPorUnidad = extrasTotal / totalUnits;
    grandTotal = 0;
    qtyInputs.forEach((input) => {
      const qty = parseInt(input.value, 10) || 0;
      if (qty > 0) grandTotal += qty * Number((precioUnitarioDe(input) + extrasPorUnidad).toFixed(2));
    });
  }
  const totalPerUnit = grandTotal / totalUnits;

  if (totalPerUnitEl) totalPerUnitEl.textContent = formatMoney(totalPerUnit);
  if (grandTotalEl)   grandTotalEl.textContent   = formatMoney(grandTotal);
  if (totalPerUnitRow) totalPerUnitRow.style.display = '';
}




function formatMoney(n) {
  return n.toFixed(2).replace('.',',') + '€';
}
function updateBreakdown() {
  const rowsContainer = document.getElementById('breakdownProductRows');
  if (!rowsContainer) return;

  rowsContainer.innerHTML = '';

  const fallbackUnitPrice = parseFloat(document.getElementById('quoteUnitPrice').value) || 0;

  document.querySelectorAll('.qty-input').forEach(input => {
    const qty = parseInt(input.value, 10) || 0;
    if (qty > 0) {
      const tr = input.closest('tr');

      // Precio por variante (si lo hay) o el general de la calculadora
      const unitPriceProd = precioUnitarioDe(input) || fallbackUnitPrice;

      // Nombre de la variante (color + talla)
      const colorCell = tr.querySelector('.color-cell');
      const sizeCell  = tr.querySelector('.size-cell');

      let colorName = 'Variante';
      if (colorCell) {
        for (const node of colorCell.childNodes) {
          if (node.nodeType === 3 && node.textContent.trim() !== '') {
            colorName = node.textContent.trim();
            break;
          }
        }
      }

      const sizeName = sizeCell ? sizeCell.innerText.trim() : '';
      const variantName = sizeName ? `${colorName} - ${sizeName}` : colorName;

      const subTotal = qty * unitPriceProd;

      const row = document.createElement('div');
      row.className = 'variant-breakdown-row';
      row.innerHTML = `
        <span>${variantName}</span>
        <span>${qty}</span>
        <span>${formatMoney(unitPriceProd)}</span>
        <span>${formatMoney(subTotal)}</span>
      `;
      rowsContainer.appendChild(row);
    }
  });
}


/* === Aviso inmediato de tamano: Shopify no admite archivos de mas de 20 MB === */
document.addEventListener('change', function (ev) {
  const inp = ev.target;
  if (!inp || !inp.matches || !inp.matches('.file-input') || !inp.files || !inp.files.length) return;
  const MAX = 20 * 1024 * 1024;
  if (inp.files[0].size > MAX) {
    alert('El archivo pesa ' + (inp.files[0].size / 1048576).toFixed(1) + ' MB y el maximo es 20 MB. Comprimelo o reduce su resolucion e intentalo de nuevo.');
    inp.value = '';
  }
});